module.exports = __webpack_public_path__ + "static/media/ss.d7cb8066.svg";